import React from "react";
import PropTypes from "prop-types";
import { time } from "./api";

export default function Item({ item, client, board, encounterId, disabled, onAction }) {
  const persistent = item.persistence === "persistent";
  const acknowledged = board.acknowledgments.some(
    (ack) =>
      ack.item_id === item.id && ack.revision === item.revision && ack.sighting_id === encounterId
  );
  const act = (operation) => onAction({ operation, item, client, encounterId });
  const active = client.follow_up === "active" && item.state === "open";
  return (
    <div className={`cb-item ${item.kind === "alert" ? "cb-item--alert" : ""}`}>
      <div className="cb-item__body">
        <div className="cb-item__tags">
          <span className={`ccw-badge ${item.kind === "alert" ? "ccw-badge--attention" : ""}`}>
            {item.kind === "alert" ? "Alert" : "Task"}
          </span>
          <span className="ccw-badge">{persistent ? "Persistent" : "One-time"}</span>
          {item.target_date && <span className="ccw-badge">Target {item.target_date}</span>}
          {item.state !== "open" && <span className="ccw-badge">{item.state}</span>}
        </div>
        <p className="cb-item__description">{item.description}</p>
        {item.revision > 1 && (
          <p className="cb-muted">
            Edited by {item.edited_by} · {time(item.edited_at, board.time_zone, true)} · revision{" "}
            {item.revision}
          </p>
        )}
        {active && (
          <div className="cb-item__actions">
            {acknowledged ? (
              <span className="ccw-badge ccw-badge--success">Acknowledged at this sighting</span>
            ) : (
              <button
                type="button"
                className="ccw-button ccw-button--compact"
                disabled={disabled}
                onClick={() => act(persistent ? "acknowledged" : "completed")}
              >
                {persistent ? "Acknowledge" : "Mark complete"}
              </button>
            )}
            {board.supervisor && item.review_due && (
              <button
                type="button"
                className="ccw-button ccw-button--compact ccw-button--warning"
                disabled={disabled}
                onClick={() => act("review")}
              >
                Review
              </button>
            )}
            <details className="ted-item-menu">
              <summary aria-label={`More actions: ${item.description}`}>More ▾</summary>
              <div className="ted-item-menu__panel">
                <button type="button" disabled={disabled} onClick={() => act("not_completed")}>
                  {item.kind === "alert" ? "Seen, not addressed" : "Seen but not completed"}
                </button>
                {persistent && (
                  <button type="button" disabled={disabled} onClick={() => act("care_performed")}>
                    {item.kind === "alert" ? "Record action taken" : "Record care performed"}
                  </button>
                )}
                {acknowledged && (
                  <button type="button" disabled={disabled} onClick={() => act("acknowledged")}>
                    Acknowledge at a new sighting
                  </button>
                )}
                <button type="button" disabled={disabled} onClick={() => act("note")}>
                  Add note
                </button>
                {board.supervisor && (
                  <button type="button" disabled={disabled} onClick={() => act("edit")}>
                    Edit wording or date
                  </button>
                )}
                {board.supervisor && persistent && (
                  <button type="button" disabled={disabled} onClick={() => act("closed")}>
                    Close item
                  </button>
                )}
              </div>
            </details>
          </div>
        )}
      </div>
    </div>
  );
}
Item.propTypes = {
  item: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  board: PropTypes.object.isRequired,
  encounterId: PropTypes.number,
  disabled: PropTypes.bool,
  onAction: PropTypes.func.isRequired
};
